// hooks/use-toast.js
"use client";
import { toast as sonnerToast } from "sonner";

// Convert your custom toast interface to work with Sonner
function toast({
  title,
  description,
  duration = 3000,
  variant = "default",
  ...props
}) {
  // Determine the toast type based on variant
  const toastType =
    variant === "destructive"
      ? "error"
      : variant === "warning"
      ? "warning"
      : variant === "info"
      ? "info"
      : "success";

  // If there's both title and description, combine them for Sonner
  if (title && description) {
    return sonnerToast[toastType](
      <div className="flex flex-col">
        <div className="font-semibold">{title}</div>
        <div className="text-sm opacity-90">{description}</div>
      </div>,
      {
        duration,
        ...props,
      }
    );
  }

  // If only title is provided
  if (title) {
    return sonnerToast[toastType](title, {
      duration,
      ...props,
    });
  }

  // If only description is provided
  if (description) {
    return sonnerToast[toastType](description, {
      duration,
      ...props,
    });
  }

  // Fallback
  return sonnerToast[toastType]("Success!", {
    duration,
    ...props,
  });
}

// Additional toast methods to match your needs
toast.success = (message, options) => {
  return sonnerToast.success(message, options);
};

toast.error = (message, options) => {
  return sonnerToast.error(message, options);
};

toast.warning = (message, options) => {
  return sonnerToast.warning(message, options);
};

toast.info = (message, options) => {
  return sonnerToast.info(message, options);
};

toast.loading = (message, options) => {
  return sonnerToast.loading(message, options);
};

toast.dismiss = (toastId) => {
  sonnerToast.dismiss(toastId);
};

toast.promise = (promise, options) => {
  return sonnerToast.promise(promise, options);
};

// Updated useToast hook to maintain compatibility with your existing code
export function useToast() {
  return {
    toast,
    dismiss: sonnerToast.dismiss,
    // Add any other methods you might need from your original implementation
  };
}

// Export the toast function directly as well (only one export)
export { toast };
